import React from 'react';
import './FaceAdd.scss';
import { connect } from 'react-redux';
import PageHelper from 'Flow2/components/Article/Helpers/PageHelper';
import CustomPopUp from 'Flow2/components/Article/Utilities/PopUp/PopUp';
import { injectIntl } from 'react-intl';
import { faSmile } from '@fortawesome/free-solid-svg-icons';
import * as actions from "store/actions/index";
import Spinner from 'Flow2/components/UI/Spinner/Spinner';

class FaceAdd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            requiredObj: {},
            data: [],
            current: {
                subject: ''
            }
        }
    }

    getBodyClasses = () => "custom-body custom-mt10";

    onCloseBtnClick = () => {
        const { faceAdd } = this.props.faceObjects;
        this.props.updatePopUpObjects({
            [`${this.props.subObjName}`]: { ...faceAdd, showOverlay: false },
            showPreview: false
        });

        if (this.props.cancelCallback) this.props.cancelCallback();
    }

    onChangeHandler = (e) => {
        const { current } = this.state;
        this.setState({ current: { ...current, subject: e.target.value } });
    }

    onConfirmClick = () => {
        const { current } = this.state;
        if (current && current.subject) {
            this.props.addSubject({ name: current.subject })
        }
        this.onCloseBtnClick();
    }

    showAddForm = () => {
        return (
            <div className="faceadd-formgroup">
                <input className="faceadd-forminput" type="text"
                    value={this.state.current.subject} onChange={this.onChangeHandler} />
            </div>
        )
    }

    displayPopUp = () => {
        return (<CustomPopUp titleIntl={this.props.titleIntl}
            contentItems={this.state.data} requiredObj={this.state.requiredObj} customIcon={faSmile}
            mainObj={this.props.faceObjects} mainObjName={this.props.mainObjName} subObjName={this.props.subObjName}
            updatePopUpObjects={this.props.updateFaceObjects} confirmCallback={this.onConfirmClick}>
            {this.showAddForm()}
        </CustomPopUp>)
    }

    componentWillUnmount() {
        this.onCloseBtnClick();
    }

    render() {
        return (
            <div className="FaceAdd" onClick={PageHelper.onPopUpClick}>
                {this.props.mainObj[`${this.props.subObjName}`].showOverlay ?
                    <div className="custom-overlay">
                        <div className="custom-preview">
                            {this.props.loading ?
                                <div className="custom-spinner-overlay"><Spinner /></div>
                                : <div />}
                            {this.displayPopUp()}
                        </div>
                    </div> : null}
            </div>
        );
    }
}

const mapStateToprops = (state) => ({
    faceObjects: state.face.faceObjects,
    loading: state.face.loading
})
const mapDispatchToProps = (dispatch) => ({
    updateFaceObjects: (obj) => dispatch(actions.updateFaceObjects(obj)),
    addSubject: (obj) => dispatch(actions.addSubject(obj))
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FaceAdd));